/* ============================================================
   SUCRÉ CAFÉ AND GO — Theme JS v2
   ============================================================ */
(function () {
  'use strict';

  var Sucre = {

    // ─── INIT ───────────────────────────────────────────────
    init: function () {
      this.countdown();
      this.sundayNotice();
      this.mobileNav();
      this.filters();
      this.qtyControls();
      this.addToCart();
      this.cartDrawer();
      this.fetchCart();
      this.deliveryCutoff();
    },

    // ─── SUNDAY PICKUP NOTICE ───────────────────────────────
    sundayNotice: function () {
      var now = new Date();
      var txTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      if (txTime.getDay() !== 0) return;

      var overlay = document.createElement('div');
      overlay.id = 'sucreSundayPop';
      overlay.style.cssText =
        'position:fixed;inset:0;z-index:400;background:rgba(94,62,51,.7);' +
        'display:flex;align-items:center;justify-content:center;padding:24px;';

      var box = document.createElement('div');
      box.style.cssText =
        'background:#F2E3C6;border:3px solid #5E3E33;border-radius:22px;max-width:400px;width:100%;' +
        'padding:40px 30px 32px;text-align:center;box-shadow:8px 8px 0 #5E3E33;' +
        "font-family:'Geologica',sans-serif;position:relative;";
      box.innerHTML =
        '<span style="position:absolute;top:-18px;left:50%;transform:translateX(-50%) rotate(-3deg);' +
        "background:#CD93A0;border:2.5px solid #5E3E33;border-radius:999px;padding:8px 18px;font-family:'Bernady',cursive;" +
        'font-size:1rem;color:#5E3E33;box-shadow:3px 3px 0 #5E3E33;white-space:nowrap;">Yeehaw, heads up!</span>' +
        '<img src="' + (window.SUCRE_CACTUS || '') + '" alt="" style="width:44px;height:auto;margin:6px auto 14px;display:block;">' +
        "<h3 style=\"font-family:'Berlian',serif;font-size:1.6rem;color:#5E3E33;margin:0 0 10px;font-weight:400;\">We\'re closed on Sundays</h3>" +
        '<p style="font-size:.92rem;color:#5E3E33;line-height:1.6;margin:0 0 22px;font-weight:300;">You can still order today. Orders placed on Sunday will be ready for pickup on <strong style="color:#596D45;">Monday from 7:00 AM</strong>.</p>' +
        "<button style=\"background:#BFA2C9;color:#5E3E33;border:2px solid #5E3E33;border-radius:999px;" +
        "padding:13px 32px;font-family:'Geologica',sans-serif;font-size:.95rem;font-weight:700;" +
        'box-shadow:4px 4px 0 #5E3E33;cursor:pointer;">Got it, see you Monday</button>' +
        '<button aria-label="Close" style="position:absolute;top:12px;right:12px;background:#fff;' +
        'border:2px solid #5E3E33;border-radius:999px;width:34px;height:34px;font-size:1rem;color:#5E3E33;' +
        'cursor:pointer;line-height:1;box-shadow:2px 2px 0 #5E3E33;">\u2715</button>';

      overlay.appendChild(box);
      document.body.appendChild(overlay);

      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { overlay.remove(); });
      });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) overlay.remove();
      });
    },


    // ─── DELIVERY CUTOFF NOTICE (after 1pm) ─────────────────
    deliveryCutoff: function () {
      // Una vez por sesión
      if (sessionStorage.getItem('sucreCutoffSeen')) return;

      var now = new Date();
      var txTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      var day = txTime.getDay();
      if (day === 0) return;              // Domingo: lo maneja sundayNotice
      if (txTime.getHours() < 13) return; // Solo después de la 1pm

      sessionStorage.setItem('sucreCutoffSeen', '1');

      var overlay = document.createElement('div');
      overlay.id = 'sucreCutoffPop';
      overlay.style.cssText =
        'position:fixed;inset:0;z-index:400;background:rgba(94,62,51,.7);' +
        'display:flex;align-items:center;justify-content:center;padding:24px;';

      var box = document.createElement('div');
      box.style.cssText =
        'background:#F2E3C6;border:3px solid #5E3E33;border-radius:22px;max-width:400px;width:100%;' +
        'padding:40px 30px 32px;text-align:center;box-shadow:8px 8px 0 #5E3E33;' +
        "font-family:'Geologica',sans-serif;position:relative;";
      box.innerHTML =
        '<span style="position:absolute;top:-18px;left:50%;transform:translateX(-50%) rotate(-3deg);' +
        "background:#CCA44A;border:2.5px solid #5E3E33;border-radius:999px;padding:8px 18px;font-family:'Bernady',cursive;" +
        'font-size:1rem;color:#5E3E33;box-shadow:3px 3px 0 #5E3E33;white-space:nowrap;">Heads up, partner!</span>' +
        '<div style="font-size:2.4rem;margin:6px 0 12px;">\uD83D\uDC34</div>' +
        "<h3 style=\"font-family:'Berlian',serif;font-size:1.6rem;color:#5E3E33;margin:0 0 10px;font-weight:400;\">Delivery cutoff</h3>" +
        '<p style="font-size:.92rem;color:#5E3E33;line-height:1.6;margin:0 0 22px;font-weight:300;">Same-day delivery orders are accepted until <strong style="color:#596D45;">1:00 PM</strong>. Orders placed after 1 PM will be delivered the <strong style="color:#596D45;">next day</strong>.</p>' +
        "<button style=\"background:#BFA2C9;color:#5E3E33;border:2px solid #5E3E33;border-radius:999px;" +
        "padding:13px 32px;font-family:'Geologica',sans-serif;font-size:.95rem;font-weight:700;" +
        'box-shadow:4px 4px 0 #5E3E33;cursor:pointer;">Got it</button>' +
        '<button aria-label="Close" style="position:absolute;top:12px;right:12px;background:#fff;' +
        'border:2px solid #5E3E33;border-radius:999px;width:34px;height:34px;font-size:1rem;color:#5E3E33;' +
        'cursor:pointer;line-height:1;box-shadow:2px 2px 0 #5E3E33;">\u2715</button>';

      overlay.appendChild(box);
      document.body.appendChild(overlay);

      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { overlay.remove(); });
      });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) overlay.remove();
      });
    },


// ─── COUNTDOWN ──────────────────────────────────────────
    countdown: function () {
      var el = document.getElementById('sucreCountdown');
      var label = document.getElementById('sucreCloseTime');

      function fmt12(h, m) {
        var ampm = h >= 12 ? 'PM' : 'AM';
        var hr = h % 12; if (hr === 0) hr = 12;
        var mm = m === 0 ? '' : ':' + String(m).padStart(2, '0');
        return hr + mm + ' ' + ampm;
      }

      // Horario por día (zona Texas). null = cerrado.
      function schedule(day) {
        if (day === 0) return null;                          // Domingo: cerrado
        if (day === 6) return { oH: 9, oM: 0, cH: 16, cM: 0 }; // Sábado: 9 AM–4 PM
        return { oH: 7, oM: 0, cH: 17, cM: 30 };             // Lun–Vie: 7 AM–5:30 PM
      }

      function tick() {
        var now = new Date();
        var txTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
        var day = txTime.getDay();
        var s = schedule(day);

        // Texto de la hora de cierre (se llena solo)
        if (label) label.textContent = s ? fmt12(s.cH, s.cM) : 'Closed';

        if (!el) return;

        if (!s) {
          el.textContent = 'Closed';
          el.style.background = 'rgba(255,255,255,.15)';
          return;
        }

        var nowMin = txTime.getHours() * 60 + txTime.getMinutes();
        var openMin = s.oH * 60 + s.oM;
        var closeMin = s.cH * 60 + s.cM;

        if (nowMin < openMin || nowMin >= closeMin) {
          el.textContent = 'Closed';
          el.style.background = 'rgba(255,255,255,.15)';
          return;
        }

        var end = new Date(txTime);
        end.setHours(s.cH, s.cM, 0, 0);
        var diff = end - txTime;

        var hrs = String(Math.floor(diff / 3600000)).padStart(2, '0');
        var min = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
        var sec = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
        el.textContent = hrs + ':' + min + ':' + sec;

        el.style.background = diff < 3600000 ? '#CD93A0' : '';
      }

      tick();
      setInterval(tick, 1000);
    },

    // ─── MOBILE NAV ─────────────────────────────────────────
    mobileNav: function () {
      var btn = document.getElementById('sucreHamburger');
      var nav = document.getElementById('sucreMobileNav');
      if (!btn || !nav) return;
      btn.addEventListener('click', function () {
        var open = !nav.hidden;
        nav.hidden = open;
        btn.setAttribute('aria-expanded', !open);
      });
    },

    // ─── FILTERS ────────────────────────────────────────────
    filters: function () {
      var btns = document.querySelectorAll('.sucre-filter');
      var rows = document.querySelectorAll('.sucre-table tbody tr[data-category]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          var cat = btn.dataset.filter || 'all';
          rows.forEach(function (row) {
            row.style.display = (cat === 'all' || row.dataset.category === cat) ? '' : 'none';
          });
        });
      });
    },

    // ─── QTY CONTROLS ───────────────────────────────────────
    qtyControls: function () {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.sucre-qty__btn');
        if (!btn) return;
        var wrap = btn.closest('.sucre-qty');
        var input = wrap && wrap.querySelector('.sucre-qty__input');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        var max = parseInt(input.dataset.max || 99, 10);
        if (btn.dataset.action === 'inc') val = Math.min(val + 1, max);
        if (btn.dataset.action === 'dec') val = Math.max(val - 1, 1);
        input.value = val;
      });
    },

// ─── ADD TO CART ────────────────────────────────────────
addToCart: function () {
  var self = this;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sucre-add-btn') || e.target.closest('.sucre-card-atc') || e.target.closest('.sucre-crs-atc') || e.target.closest('.sucre-mcard-atc');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.dataset.variantId || btn.dataset.variant || btn.dataset.id;
    if (!id) { self.toast('Could not add this item.'); return; }

    // Cantidad desde el input de qty más cercano (si existe)
    var row = btn.closest('tr') || btn.closest('.sucre-card') || btn.closest('.sucre-mcard') || btn.closest('.sucre-crs-item');
    var qtyInput = row && row.querySelector('.sucre-qty__input');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { self.toast('Sorry, this item is unavailable right now.'); return; }
        self.fetchCart();
        self.openDrawer();
        self.toast('Added to your order ✓');
      })
      .catch(function () { self.toast('Something went wrong. Please try again.'); })
      .finally(function () { btn.disabled = false; });
  });
},

    // ─── FETCH CART ─────────────────────────────────────────
    fetchCart: function () {
      var self = this;
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.updateUI(cart); })
        .catch(function (err) { console.warn('Cart fetch error:', err); });
    },

    // ─── UPDATE UI ──────────────────────────────────────────
    updateUI: function (cart) {
      var count = cart.item_count || 0;
      var total = this.money(cart.total_price || 0);

      // Nav badge
      document.querySelectorAll('.sucre-cart-count').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });

      // Sticky bar
      var bar = document.getElementById('sucreCartBar');
      if (bar) {
        var countEl = bar.querySelector('.sucre-cart-bar__count');
        var totalEl = bar.querySelector('.sucre-cart-bar__total');
        if (countEl) countEl.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
        if (totalEl) totalEl.textContent = total;
        count > 0 ? bar.classList.add('is-visible') : bar.classList.remove('is-visible');
      }

      // Drawer items
      this.renderDrawerItems(cart);

      // Drawer subtotal
      var totalDrawer = document.getElementById('sucreCartTotal');
      if (totalDrawer) totalDrawer.textContent = total;
    },

    // ─── RENDER DRAWER ITEMS ────────────────────────────────
    renderDrawerItems: function (cart) {
      var container = document.getElementById('sucreCartItems');
      if (!container) return;
      var self = this;
      if (!cart.items || cart.items.length === 0) {
        container.innerHTML = '<div class="sucre-cart-empty"><span>☕</span><p>Your order is empty</p><small>Add something from today\'s menu</small></div>';
        return;
      }
container.innerHTML = cart.items.map(function (item) {
        var imgHtml = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url + '" alt="' + item.product_title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
          : '☕';
        var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? '<small style="color:#CD93A0;font-weight:600;display:block;">' + item.variant_title + '</small>'
          : '';
        var qtyHtml = '<div style="display:inline-flex;align-items:center;border:1.5px solid #CD93A0;border-radius:50px;overflow:hidden;margin-top:6px;">' +
          '<button class="sucre-drawer-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" style="width:28px;height:28px;border:none;background:transparent;font-size:1rem;cursor:pointer;color:#5E3E33;font-weight:700;">−</button>' +
          "<span style=\"width:24px;text-align:center;font-family:'Geologica',sans-serif;font-size:.85rem;color:#5E3E33;\">" + item.quantity + "</span>" +
          '<button class="sucre-drawer-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" style="width:28px;height:28px;border:none;background:transparent;font-size:1rem;cursor:pointer;color:#5E3E33;font-weight:700;">+</button>' +
          '</div>';
        return '<div class="sucre-cart-item" data-key="' + item.key + '">' +
          '<div class="sucre-cart-item__img">' + imgHtml + '</div>' +
          '<div class="sucre-cart-item__info"><strong>' + item.product_title + '</strong>' + variantHtml + qtyHtml + '</div>' +
          '<span class="sucre-cart-item__price">' + self.money(item.line_price) + '</span>' +
          '<button class="sucre-cart-item__remove" data-key="' + item.key + '" aria-label="Remove">×</button>' +
          '</div>';
      }).join('');

      container.querySelectorAll('.sucre-cart-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () { self.removeItem(btn.dataset.key); });
      });
      container.querySelectorAll('.sucre-drawer-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.key;
          var qty = parseInt(btn.dataset.qty);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: key, quantity: qty })
          }).then(function () { self.fetchCart(); });
        });
      });
    },

    // ─── REMOVE ITEM ────────────────────────────────────────
    removeItem: function (key) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function () { self.fetchCart(); })
      .catch(function (e) { console.warn(e); });
    },

    // ─── CART DRAWER ────────────────────────────────────────
    cartDrawer: function () {
      var self = this;
      var overlay = document.getElementById('sucreOverlay');
      var drawer = document.getElementById('sucreCartDrawer');
      var closeBtn = document.getElementById('sucreCartClose');

      document.querySelectorAll('.sucre-cart-btn').forEach(function (btn) {
        btn.addEventListener('click', function () { self.openDrawer(); });
      });
      if (closeBtn) closeBtn.addEventListener('click', function () { self.closeDrawer(); });
      if (overlay) overlay.addEventListener('click', function () { self.closeDrawer(); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer && !drawer.hidden) self.closeDrawer();
      });
    },

    openDrawer: function () {
      var overlay = document.getElementById('sucreOverlay');
      var drawer = document.getElementById('sucreCartDrawer');
      if (overlay) overlay.classList.add('is-open');
      if (drawer) { drawer.hidden = false; drawer.classList.add('is-open'); drawer.focus(); }
      document.body.style.overflow = 'hidden';
      var cartBtn = document.getElementById('sucreCartBtn');
      if (cartBtn) cartBtn.setAttribute('aria-expanded', 'true');
    },

    closeDrawer: function () {
      var overlay = document.getElementById('sucreOverlay');
      var drawer = document.getElementById('sucreCartDrawer');
      if (overlay) overlay.classList.remove('is-open');
      if (drawer) { drawer.classList.remove('is-open'); setTimeout(function () { if (drawer) drawer.hidden = true; }, 350); }
      document.body.style.overflow = '';
      var cartBtn = document.getElementById('sucreCartBtn');
      if (cartBtn) cartBtn.setAttribute('aria-expanded', 'false');
    },

    // ─── TOAST ──────────────────────────────────────────────
    toast: function (msg) {
      var container = document.getElementById('sucre-toast');
      if (!container) return;
      var item = document.createElement('div');
      item.className = 'sucre-toast__item';
      item.innerHTML = '<span>✓</span><span>' + msg + '</span>';
      container.appendChild(item);
      requestAnimationFrame(function () { requestAnimationFrame(function () { item.classList.add('is-show'); }); });
      setTimeout(function () {
        item.classList.remove('is-show');
        setTimeout(function () { if (item.parentNode) item.parentNode.removeChild(item); }, 400);
      }, 3000);
    },

    // ─── FORMAT MONEY ───────────────────────────────────────
    money: function (cents) {
      var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace('{{amount}}', amount)
                .replace('{{amount_no_decimals}}', Math.round(cents / 100))
                .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }

  };

  document.addEventListener('DOMContentLoaded', function () { Sucre.init(); });

})();
